// src/store/index.js
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    userUid: "1",
    userArray: [],
    randomSelectedData: [],
    examTitle: {},
    
    // ✅ 初始化为 null，表示未加载
    // 小车
    // 科目一
    questions_direction: null,
    questions_indication: null,
    questions_prohibition: null,
    warningSign: null,
    questions_road_marking: null,
    questions_dashboard: null,
    questions_signal_light: null,
    questions_light_abbrev: null,
    questions_speed_dist: null,
    questions_fine_law: null,
    questions_carry_items: null,
    questions_yearCommonSense: null,
    questions_car_type: null,
    questions_score_punish: null,
    questions_light_usage: null,
    questions_weather_road: null,
    questions_civil_1: null,
    questions_civil_2: null,
    questions_civil_3: null,
    questions_civil_4: null,
    questions_local_questions: null,
    // 小车
    // 科目四
    questions_subject4_road_signs: null,
    questions_subject4_highway_signs: null,
    questions_subject4_police: null,
    questions_subject4_prohibition: null,
    questions_subject4_indication: null,
    questions_subject4_road_marking: null,
    // 待补充
    questions_subject4_civil_1: null,
    questions_subject4_civil_2: null,
    questions_subject4_civil_3: null,
    questions_subject4_civil_4: null,
    questions_subject4_civil_5: null,
    questions_subject4_light_usage: null,
    questions_subject4_weather: null,
    questions_subject4_first_aid: null,
    questions_subject4_overload: null,
    questions_subject4_multiple_choice: null,



    // 记录正在加载的 key，防止重复请求
    loadingKeys: [], 
  },

  mutations: {
    SET_SINGLE_DATA(state, { key, data }) {
      state[key] = data;
      const index = state.loadingKeys.indexOf(key);
      if (index > -1) state.loadingKeys.splice(index, 1);
    },

    SET_LOADING_KEY(state, key) {
      if (!state.loadingKeys.includes(key)) {
        state.loadingKeys.push(key);
      }
    },

    // src/store/index.js 中的 mutations 部分
    // src/store/index.js 中的 mutations 部分

    GENERATE_RANDOM_DATA_V2(state, { count = 100, sourceKeys }) {
      const allSourceData = [];
      count
      // 1. 汇聚所有源数据
      sourceKeys.forEach((key) => {
        const dataList = state[key];
        if (key != 'questions_local_questions') {
          if (Array.isArray(dataList)) {
            allSourceData.push(...dataList);
            console.log(allSourceData)
          }
        }
      });
      if (allSourceData.length === 0) {
        console.warn("[Store] 源数据为空，无法生成模拟题");
        state.randomSelectedData = [];
        return;
      }

      // 2. 判断是否为科目四
      const isSubject4 = sourceKeys.some(key => key.includes('subject4'));
      
      let finalQuestions = [];

      if (isSubject4) {
        // --- ✅ 科目四专属逻辑：严格分段组卷 ---
        // 目标：20 判断 + 20 单选 + 10 多选 = 50 题
        
        const targetJudge = 20;
        const targetSingle = 20;
        const targetMulti = 10;

        // 分类数据池
        const judgePool = allSourceData.filter(item => 
          item.type === "判断题" || item.type === "judge"
        );
        
        const singlePool = allSourceData.filter(item => 
          item.type === "单选题" || item.type === "choice" || (!item.type && item.options && item.options.length === 4)
        );
        
        const multiPool = allSourceData.filter(item => 
          item.type === "多选题" || item.type === "multiple"
        );

        // 通用随机抽取函数 (不修改原数组)
        const randomSelectFromPool = (pool, count) => {
          if (!pool || pool.length === 0) return [];
          const availableCount = Math.min(count, pool.length);
          
          if (availableCount < count) {
            console.warn(`[Store] 题库警告：${pool === judgePool ? '判断题' : pool === singlePool ? '单选题' : '多选题'} 数量不足，期望 ${count}，实际可用 ${pool.length}`);
          }

          const tempPool = [...pool];
          // Fisher-Yates 洗牌前 N 个
          for (let i = 0; i < availableCount; i++) {
            const randomIndex = i + Math.floor(Math.random() * (tempPool.length - i));
            [tempPool[i], tempPool[randomIndex]] = [tempPool[randomIndex], tempPool[i]];
          }
          return tempPool.slice(0, availableCount);
        };

        // 执行分段抽取
        const selectedJudges = randomSelectFromPool(judgePool, targetJudge);
        const selectedSingles = randomSelectFromPool(singlePool, targetSingle);
        const selectedMultis = randomSelectFromPool(multiPool, targetMulti);

        // 按顺序合并：先判断，再单选，最后多选
        finalQuestions = [
          ...selectedJudges,
          ...selectedSingles,
          ...selectedMultis
        ];

        console.log(`[Store] ✅ 科目四模拟卷生成成功:`);
        console.log(`   - 判断题：${selectedJudges.length} (目标 ${targetJudge})`);
        console.log(`   - 单选题：${selectedSingles.length} (目标 ${targetSingle})`);
        console.log(`   - 多选题：${selectedMultis.length} (目标 ${targetMulti})`);
        console.log(`   - 总题数：${finalQuestions.length}`);

      } else {
        // --- 科目一原有逻辑 (保持 70 单选 + 30 判断) ---
        const singleCountNeeded = 70; 
        const tfCountNeeded = 30;

        const singleChoices = allSourceData.filter(item => 
          item.type === "单选题" || item.type === "choice" || !item.type
        );
        
        const trueFalseQuestions = allSourceData.filter(item => 
          item.type === "判断题" || item.type === "judge"
        );

        const randomSelect = (sourceArray, count) => {
          const availableCount = Math.min(count, sourceArray.length);
          if (availableCount === 0) return [];
          const pool = [...sourceArray]; 
          for (let i = 0; i < availableCount; i++) {
            const randomIndex = i + Math.floor(Math.random() * (pool.length - i));
            [pool[i], pool[randomIndex]] = [pool[randomIndex], pool[i]];
          }
          return pool.slice(0, availableCount);
        };

        const selectedSingles = randomSelect(singleChoices, singleCountNeeded);
        const selectedTFs = randomSelect(trueFalseQuestions, tfCountNeeded);

        finalQuestions = [...selectedSingles, ...selectedTFs];
        console.log(`[Store] 科目一模拟卷生成：单选${selectedSingles.length} + 判断${selectedTFs.length}`);
      }

      state.randomSelectedData = finalQuestions;
    },

  },

   actions: {
    /**
     * 动态加载题库 Action
     * @param {String} key - Vuex state 中的键名
     * @param {String} fileName - 具体的 json 文件名
     * @param {String} vehicleKey - 车型 (car, truck, motorcycle)
     */
    async loadSingleDataSet({ commit, state }, { key, fileName, vehicleKey = 'car' }) {
      // 1. 如果数据已存在且是数组，直接返回成功
      if (state[key] && Array.isArray(state[key])) {
        // console.log(`[Store][Cache Hit] ✅ ${key} 已缓存 (${state[key].length}题)，跳过网络请求`);
        return Promise.resolve(state[key]);
      }

      // 2. 如果正在加载中，等待完成 (防止重复并发请求)
      if (state.loadingKeys.includes(key)) {
        // console.log(`[Store][Waiting] ⏳ ${key} 正在加载中，等待完成...`);
        return new Promise((resolve, reject) => {
          const checkInterval = setInterval(() => {
            if (!state.loadingKeys.includes(key)) {
              clearInterval(checkInterval);
              if (state[key] && Array.isArray(state[key])) {
                resolve(state[key]);
              } else {
                reject(new Error('加载完成但数据为空'));
              }
            }
          }, 100);
          
          // 超时保护 (8秒)
          setTimeout(() => {
            clearInterval(checkInterval);
            reject(new Error(`等待 ${key} 加载超时`));
          }, 8000);
        });
      }

      // 3. 标记开始加载
      commit('SET_LOADING_KEY', key);
      
      try {
        // --- 核心路径逻辑 ---
        let targetSubjectFolder = 'smallCarOne'; // 默认科目一

        // 判断逻辑：只要 key 或 fileName 包含 'subject4'，就认为是科目四
        if (key.includes('subject4') || fileName.includes('subject4')) {
          targetSubjectFolder = 'smallCarFour';
        }

        // 映射车型文件夹
        const vehicleMap = {
          'car': 'car',
          'truck': 'truck',
          'motorcycle': 'motorcycle'
        };
        const finalVehicleFolder = vehicleMap[vehicleKey] || 'car';

        // 构造完整 URL
        // 假设你的 public 目录结构是: /public/car/smallCarOne/json/xxx.json
        const url = `/${finalVehicleFolder}/${targetSubjectFolder}/json/${fileName}`;
        
        // console.group(`[Store][Request] 🌐 正在请求数据: ${key}`);
        // console.log('📁 目标路径:', url);
        // console.log('🚗 车型:', finalVehicleFolder);
        // console.log('📚 科目文件夹:', targetSubjectFolder);
        // console.groupEnd();
        
        const response = await fetch(url);
        
        if (!response.ok) {
          // 详细错误信息
          const errorMsg = `HTTP ${response.status}: 文件未找到或服务器错误`;
          console.error(`[Store][Error] ❌ ${errorMsg} -> URL: ${url}`);
          throw new Error(errorMsg);
        }
        
        const data = await response.json();
        
        if (!Array.isArray(data)) {
          console.error(`[Store][Format Error] ❌ 数据格式错误：返回的不是数组。URL: ${url}`, data);
          throw new Error(`数据格式错误：返回的不是数组`);
        }

        // 提交 Mutation 更新状态
        commit('SET_SINGLE_DATA', { key, data });
        // console.log(`[Store][Success] ✅ 成功加载 ${key} : ${data.length} 道题`);
        return data;
        
      } catch (error) {
        // console.error(`[Store][Catch] 💥 加载 ${key} 发生异常:`, error);
        
        // 出错时务必移除加载标记，否则下次永远卡在"加载中"
        const index = state.loadingKeys.indexOf(key);
        if (index > -1) state.loadingKeys.splice(index, 1);
        
        // 【重要】出错时设置为空数组，防止页面崩溃，但会在控制台报错
        // 如果你想让页面显示"加载失败"而不是"0道题”，可以在这里不设置空数组，而是抛出一个特定标志
        commit('SET_SINGLE_DATA', { key, data: [] });
        
        // 重新抛出错误，让组件层知道失败了（组件里可以弹 Toast）
        throw error;
      }
    },
    
    generateRandomDataSet({ commit }, payload) {
      commit("GENERATE_RANDOM_DATA_V2", payload);
    },
  },
  
  modules: {},
});

export default store;